export enum AuthStatus {
  Pending = 'pending',
  Authenticated = 'authenticated',
  NotAuthenticated = 'not-authenticated',
}
